import { Grid, Box, Typography } from '@mui/material';

interface Schedule {
  id: string;
  day_of_week: number;
  start_time: string;
  end_time: string;
  interval_minutes: number;
  is_active: boolean;
}

function isOpenDay(schedule: { start_time: string; end_time: string; }) {
  return !(schedule.start_time === '00:00:00' && schedule.end_time === '00:00:00');
}

interface RoomStatsProps {
  schedules: Schedule[];
}

export function RoomStats({ schedules }: RoomStatsProps) {
  const allSchedules = (schedules || [])
    .filter((schedule: Schedule) => schedule.is_active)
    .sort((a: Schedule, b: Schedule) => a.day_of_week - b.day_of_week);

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid item xs={12} sm={4}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography fontWeight={700} fontSize={20} color="#22C55E">
            {allSchedules.filter((s: Schedule) => isOpenDay(s)).length}
          </Typography>
          <Typography fontSize={12} color="#6B7280">Dias abertos</Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography fontWeight={700} fontSize={20} color="#EF4444">
            {allSchedules.filter((s: Schedule) => !isOpenDay(s)).length}
          </Typography>
          <Typography fontSize={12} color="#6B7280">Dias fechados</Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Box sx={{ textAlign: 'center' }}>
          <Typography fontWeight={700} fontSize={20} color="#3B4EFF">
            {allSchedules.length}
          </Typography>
          <Typography fontSize={12} color="#6B7280">Total configurado</Typography>
        </Box>
      </Grid>
    </Grid>
  );
} 